// (function (unsafeWindow) {
// /* eslint-disable */
// // ==UserScript==
// // @name extern api
// // @description TvInfo_socket api
// // @match <all_urls>
// // @exclude file:///usr/local/opt/webengine/resources/status_page/*
// // @exclude https://www.gstatic.com/webassistant/*
// // @run-at document-start
// // ==/UserScript==

// (function() {
//     if (!!window.__omi_window_type &&
//     window.__omi_window_type != 'generic' &&
//     window.__omi_window_type != 'tv_store') {
//         return
//     }

//     if (!['VIDAA', 'HbbTV'].some(key => navigator.userAgent.includes(key))) {
//         let url = new URL(location.href)
//         if (url?.hostname?.includes("starplus.com")) {
//             console.log('starplus in tvbrowser, skip this userjs.')
//             return
//         }
//     }

//     console.log('Into tvinfo_client_phoenix.user.js.')
//     var TvInfo_Json = {}
//     window.vowOS = {}
//     window.vowOS.service = {
//         socket: null, // we don't connect server automatically as many app don't user js service;
//         port: 9888,
//         session_array: {},
//         session: 0,
//         msgs: [], // for cache msgs in case socket haven't connected
//         httpRequest: null,

//         isObject: function(data) {
//             return typeof data === 'object'
//         },

//         /*
//          * service: service name, same as xxx in phoenix://service/xxx
//          * api: api called, same as api@parameter in execute function
//          * example: syncExecute("hiutils","hiSdkSignCreate"). service is service name
//          */
//         syncExecute: function(service, args) {
//             if (!args?.api) {
//                 console.error('wrong parameter, should set api')
//                 return false
//             }
//             if (this.httpRequest == null) httpRequest = new XMLHttpRequest()
//             const url = 'http://localhost:9009/service/' + service
//             console.log('post request to ' + url)
//             httpRequest.open('POST', url, false)
//             httpRequest.send(JSON.stringify(args))
//             if (httpRequest.status == 200) {
//                 if (typeof httpRequest.responseText == 'string') {
//                     const ret = JSON.parse(httpRequest.responseText)
//                     delete ret.session
//                     return ret
//                 }
//                 return true
//             } else {
//                 console.error('http request failed:' + httpRequest.status)
//                 return false
//             }
//         },

//         execute: function(module, obj_params) {
//             if (module.indexOf('phoenix://service') != 0) {
//                 console.error('wrong scheme format, should be : phoenix://service/xxx !')
//             }

//             if (this.socket == null) {
//                 this.socket = new WebSocket('wss://localhost:' + this.port)
//                 this.socket.onopen = this.socketonopen
//                 this.socket.onmessage = this.socketonmessage
//                 this.socket.onclose = this.socketonclose
//                 this.socket.onerror = this.socketonerror
//             }

//             const cmd = {
//                 path: module,
//                 method: '',
//                 parameters: {},
//                 session: this.session++, // this need be set everytime
//                 timeout: 10, // default is 10
//                 identifier: '0' // resolved
//             }

//             // check input
//             if (!this.isObject(obj_params)) {
//                 console.error('wrong parameter, input should be Json format!')
//                 return false
//             }

//             cmd.method = obj_params?.method ?? ''
//             cmd.timeout = obj_params?.timeout ?? 10

//             if (obj_params?.parameters) {
//                 // check input
//                 if (!this.isObject(obj_params.parameters)) {
//                     console.error('wrong parameter, input should be Json format!')
//                     return false
//                 }

//                 if (!obj_params.parameters?.api) {
//                     console.error('wrong parameter, should set api or args!')
//                     return false
//                 }
//                 cmd.parameters = obj_params.parameters
//             }

//             // save session data
//             this.session_array[cmd.session] = obj_params

//             if (this.socket.readyState == WebSocket.OPEN) {
//                 this.socket.send(JSON.stringify(cmd))
//                 // console.log("send out cmd: "+JSON.stringify(cmd))
//             } else {
//                 this.msgs.push(JSON.stringify(cmd))
//             }

//             return true
//         }
//     }

//     window.vowOS.tvinfo = {
//         apiVersion: '3.0.1',
//         getUIVersion: function() {
//             const ret = window.vowOS.service.syncExecute('hiutils', {
//                   api: 'getUIVersion',
//                   args: ''
//             })

//             if(ret?.ret) {
//                 return JSON.parse(ret.msg)
//             }
//         },
//         getOSVersion: function() {
//             const ret = window.vowOS.service.syncExecute('hiutils', {
//                   api: 'getOSVersion',
//                   args: ''
//             })

//             if(ret?.ret) {
//                 return ret?.msg
//             }
//         },
//         getStoreMode: function() {
//             return TvInfo_getParam('storeMode')
//         },
//         getHotelMode: function() {
//             return TvInfo_getParam('isHotelMode')
//         },
//         getKidsMode: function() {
//             return TvInfo_getParam('kidsMode')
//         },
//         setKidsMode: function(data) {
//             return TvInfo_setParam('kidsMode', data)
//         },
//         getPanelType: function() {
//             return TvInfo_getParam('panelType')
//         },
//         getTimeFormat: function() {
//             return TvInfo_getParam('timeFormat')
//         },
//         setBrightness: function(data) {
//             return TvInfo_setParam('brightness', data)
//         },
//         getBrightness: function() {
//             return TvInfo_getParam('brightness')
//         },
//         setContrast: function(data) {
//             return TvInfo_setParam('contrast', data)
//         },
//         getContrast: function() {
//             return TvInfo_getParam('contrast')
//         },
//         getChipId: function() {
//             return TvInfo_getParam('chipId')
//         }
//     }

//     window.vowOS.store = {
//         getInstalledPkgs: function() {
//             const ret = window.vowOS.service.syncExecute('pkgmgr', {
//                   api: 'getInstalledPkgs',
//                   args: ''
//             })
//             return ret
//         },
//         installApp: function(appinfo, callback) {
//             if (!appinfo || typeof (appinfo) != 'object') {
//                 callback({ret: false, msg:{appId: '', message:'wrong param'}})
//                 return false
//             }
//             if(!appinfo?.packageName) {
//                 const ret = Hisense_installApp(appinfo.appId, appinfo.appName, appinfo.thumbnail, appinfo.iconSmall, appinfo.iconBig, appinfo.appUrl, appinfo.storetype, callback, appinfo.configUrl, appinfo.configUrlDownload, appinfo.mediaId)
//                 callback({ret: ret, msg:{appId: appinfo?.appId, message: ret? "succeed" : "install failed!"}})
//                 return ret
//             } else {
//                 // package app
//                 const param = {
//                      pkgName: appinfo?.packageName,
//                      version: '',
//                      appId: appinfo?.appId
//                 }
//                 this.sendPkgmgrRequest('install', param, appinfo, callback)
//                 return true
//             }
//         },

//         sendPkgmgrRequest: function(api, args, appinfo, callback) {
//             let ret = true
//             // encode param
//             const encodedData = encodeURIComponent(JSON.stringify(args));
//             const url = `https://localhost:9888/service/pkgmgr?api=${api}&args=${encodedData}`;
//             const xhr = new XMLHttpRequest();
//             xhr.onload = function() {
//                 if (xhr.status >= 200 && xhr.status < 300) {
//                     // 请求成功，处理响应数据
//                     console.log(xhr.responseText)
//                     const response = JSON.parse(xhr.responseText)
//                     if(response?.ret && api == 'install') {
//                         // TODO: read from config file
//                         const path = `file:///APPS/pkgs/${args?.pkgName}/index.html`
//                         // write path into Appinfo.json
//                         ret = Hisense_installApp(args?.appId, args?.pkgName, appinfo?.thumbnail, appinfo?.iconSmall, appinfo?.iconBig, path, 'hisense', callback, appinfo?.configUrl, appinfo?.configUrlDownload, appinfo?.mediaId)
//                     }

//                     callback({ret: response?.ret, msg:{appId: args?.appId, message: response?.msg}})
//                 } else {
//                     // 请求失败，处理错误
//                     ret = false
//                     callback({ret: ret, msg:{appId: args?.appId, message: xhr.responseText}})
//                 }
//             }

//             xhr.open('GET', url);
//             xhr.send();
//             return ret
//         }
//     }

//     window.vowOS.service.socketonopen = function(e) {
//         console.log('websocket opened')
//         if (vowOS.service.msgs.length > 0) vowOS.service.msgs.reverse()
//         while (vowOS.service.msgs.length > 0) {
//             vowOS.service.socket.send(vowOS.service.msgs.pop())
//         }
//     }

//     window.vowOS.service.socketonmessage = function(e) {
//         console.log('websocket received message:' + e.data)
//         try {
//             const params = JSON.parse(e.data)
//             const vidainfo = JSON.stringify(e.data);
//             const callbacks = vowOS.service.session_array[params.session] != undefined ? vowOS.service.session_array[params.session] : {}
//             const event_return = callbacks?.onMessage

//             console.log('callbacks:', params, params.msg.deviceID, params.msg.deviceModel, params.msg.osVersion, params.msg.serialNumber);

//             localStorage.setItem("deviceIDInfo", params.msg.deviceID);
//             localStorage.setItem("modelCode", params.msg.capabilityCode);
//             localStorage.setItem("version", params.msg.osVersion);
//             localStorage.setItem("serialNumber", params.msg.serialType);
//             localStorage.setItem("macAddress", params.msg.deviceID);
//             localStorage.setItem("uuid", params.msg.chipsetName);
//             localStorage.setItem("systemInfo", params.msg.tvBrand);
//             localStorage.setItem("modelName", params.msg.modelName);

//             // handle event
//             if (event_return && params?.event) {
//                 const event = {
//                     event: params?.event ?? 'unknown',
//                     msg: params?.msg ?? 'invalid format'
//                 }
//                 return callbacks.onMessage(event)
//             }
//             // handle api case
//             if (params.ret) {
//                 callbacks?.onSuccess?.(params.msg)
//             } else {
//                 callbacks?.onError?.(params.msg)
//             }

//             callbacks?.onComplete?.(params.msg)
//             if (callbacks.method != 'register') {
//                 console.log('removed session:' + params.session)
//                 delete vowOS.service.session_array[params.session]
//             }
//         } catch (e) {
//             console.log(e)
//         }
//     }

//     // e.reason = session
//     window.vowOS.service.socketonclose = function(e) {
//         console.log('websocket closed, code:%d / reason:%s', e.code, e.reason)

//         vowOS.service.socket = null
//         vowOS.service.msgs.length = []

//         for (const session in vowOS.service.session_array) {
//             if (vowOS.service.session_array[session]?.onError) {
//                 const callbacks = vowOS.service.session_array[session]
//                 delete vowOS.service.session_array[session]
//                 console.log('call onError for session %s!', session)
//                 callbacks.onError('session is closed abnormally.code ' + e.code)
//             }
//         }
//     }

//     window.vowOS.service.socketonerror = function(error) {
//         console.log('got error:' + error.msg)
//     }

//     // get param
//     TvInfo_getParam = function(key) {
//         if (!(TvInfo_Json.hasOwnProperty(key) && TvInfo_Json[key] != undefined)) {
//             var ret = vowOS.service.syncExecute('tvinfo', {
//                 api: key
//             })

//             if (ret?.ret) {
//                 var value = ret?.msg
//                 if (value[key] != null) {
//                     console.log('[tvinfo] key:' + key + ', value: ' + value[key])
//                     return value[key]
//                 }
//             } else {
//                 console.log('HTTP ERROR CODE: ' + ret.msg)
//             }

//             return null
//         }

//         console.log('[tvinfo] key:' + key + ', value: ' + TvInfo_Json[key])
//         return TvInfo_Json[key]
//     }

//     // set param
//     TvInfo_setParam = function(key, value) {
//         vowOS.service.execute('phoenix://service/tvinfo', {
//             method: 'callAPI',
//             parameters: {
//                 api: 'setbiz',
//                 args: {
//                     key: key,
//                     value: value.toString()
//                 }
//             },
//             timeout: 2,
//             onSuccess: function(ret) { console.log('got result: %d - %s', ret) }
//         })

//         return true
//     }

//     // get param
//     TvInfo_getCurrentParam = function(key, value) {
//         const xhr_response = vowOS.service.syncExecute('tvinfo', {
//             api: key,
//             args: value
//         })
//         return xhr_response.msg
//     }

//     // set Observer
//     TvInfo_setParamObserver = function(key, callback) {
//         console.log('set observer: ' + key)
//         vowOS.service.execute('phoenix://service/tvinfo', {
//             method: 'register',
//             parameters: {
//                 api: key
//             },
//             timeout: 2,
//             onMessage: function(ret) {
//                 if (ret) {
//                     updateJSON(ret)
//                     callback(ret?.msg)
//                 }
//             }
//         })

//         return true
//     }

//     // clear observe
//     TvInfo_clearParamObserver = function(key) {
//         console.log('unregister observer: ' + key)
//         vowOS.service.execute('phoenix://service/tvinfo', {
//             method: 'unregister',
//             parameters: {
//                 api: key
//             },
//             timeout: 2
//         })

//         return true
//     }

//     // log report
//     TvInfo_writeTvRunLog = function(type, msg) {
//         var runlog = {}
//         runlog.type = type
//         runlog.msg = msg
//         vowOS.service.execute('phoenix://service/hiutils', {
//             method: 'callAPI',
//             parameters: {
//                 api: 'writeTvRunLog',
//                 args: JSON.stringify(runlog)
//             },
//             timeout: 2,
//             onSuccess: function(ret) { console.log('got result: %d - %s', ret) }
//         })
//         return true
//     }

//     // hi_utils
//     HiUtils_createRequest = function(type, msg) {
//         const xhr_response = vowOS.service.syncExecute('hiutils', {
//             api: type,
//             args: msg
//         })
//         return xhr_response
//     }

//     onLoadPage()

//     // ====================================================
//     function onLoadPage() {
//     // create websocket
//     // console.time("WebsocketTest");
//         createWebsocket()
//     }

//     // create websocket
//     function createWebsocket() {
//         try {
//             init()
//         } catch (e) {
//             console.log('websocket error')
//         }
//     }

//     function init() {
//         vowOS.service.execute('phoenix://service/tvinfo', {
//             method: 'callAPI',
//             parameters: {
//                 api: 'initialData'
//             },
//             timeout: 2,
//             onSuccess: function(ret) { addToJSON(ret) }
//         })
//     }

//     function addToJSON(str) {
//         if (!!str && typeof str == 'object') {
//             for (var k in str) {
//                 TvInfo_Json[k] = str[k]
//             }
//             return true
//         } else {
//             return false
//         }
//     }

//     function updateJSON(data) {
//         console.log('update JSON: ', JSON.stringify(data))
//         if (data && typeof data == 'object') {
//             TvInfo_Json[data?.event] = data?.msg
//             return true
//         } else {
//             return false
//         }
//     }
// })()

// })(window);


import React, { useEffect, useState } from "react";
import { json } from "react-router-dom";

const VidaaTVInfo = () => {
  const [systemInfo, setSystemInfo] = useState(null);

  useEffect(() => {
    const getSystemInfo = function(e) {
      try {
        (function (unsafeWindow) {
          /* eslint-disable */
          // ==UserScript==
          // @name extern api
          // @description TvInfo_socket api
          // @match <all_urls>
          // @exclude file:///usr/local/opt/webengine/resources/status_page/*
          // @exclude https://www.gstatic.com/webassistant/*
          // @run-at document-start
          // ==/UserScript==
          
          (function() {
              if (!!window.__omi_window_type &&
              window.__omi_window_type != 'generic' &&
              window.__omi_window_type != 'tv_store') {
                  return
              }
          
              if (!['VIDAA', 'HbbTV'].some(key => navigator.userAgent.includes(key))) {
                  let url = new URL(location.href)
                  if (url?.hostname?.includes("starplus.com")) {
                      console.log('starplus in tvbrowser, skip this userjs.')
                      return
                  }
              }
          
              console.log('Into tvinfo_client_phoenix.user.js.')
              var TvInfo_Json = {}
              window.vowOS = {}
              window.vowOS.service = {
                  socket: null, // we don't connect server automatically as many app don't user js service;
                  port: 9888,
                  session_array: {},
                  session: 0,
                  msgs: [], // for cache msgs in case socket haven't connected
                  httpRequest: null,
          
                  isObject: function(data) {
                      return typeof data === 'object'
                  },
          
                  /*
                   * service: service name, same as xxx in phoenix://service/xxx
                   * api: api called, same as api@parameter in execute function
                   * example: syncExecute("hiutils","hiSdkSignCreate"). service is service name
                   */
                  syncExecute: function(service, args) {
                      if (!args?.api) {
                          console.error('wrong parameter, should set api')
                          return false
                      }
                      if (this.httpRequest == null) httpRequest = new XMLHttpRequest()
                      const url = 'http://localhost:9009/service/' + service
                      console.log('post request to ' + url)
                      httpRequest.open('POST', url, false)
                      httpRequest.send(JSON.stringify(args))
                      if (httpRequest.status == 200) {
                          if (typeof httpRequest.responseText == 'string') {
                              const ret = JSON.parse(httpRequest.responseText)
                              delete ret.session
                              return ret
                          }
                          return true
                      } else {
                          console.error('http request failed:' + httpRequest.status)
                          return false
                      }
                  },
          
                  execute: function(module, obj_params) {
                      if (module.indexOf('phoenix://service') != 0) {
                          console.error('wrong scheme format, should be : phoenix://service/xxx !')
                      }
          
                      if (this.socket == null) {
                          this.socket = new WebSocket('wss://localhost:' + this.port)
                          this.socket.onopen = this.socketonopen
                          this.socket.onmessage = this.socketonmessage
                          this.socket.onclose = this.socketonclose
                          this.socket.onerror = this.socketonerror
                      }
          
                      const cmd = {
                          path: module,
                          method: '',
                          parameters: {},
                          session: this.session++, // this need be set everytime
                          timeout: 10, // default is 10
                          identifier: '0' // resolved
                      }
          
                      // check input
                      if (!this.isObject(obj_params)) {
                          console.error('wrong parameter, input should be Json format!')
                          return false
                      }
          
                      cmd.method = obj_params?.method ?? ''
                      cmd.timeout = obj_params?.timeout ?? 10
          
                      if (obj_params?.parameters) {
                          // check input
                          if (!this.isObject(obj_params.parameters)) {
                              console.error('wrong parameter, input should be Json format!')
                              return false
                          }
          
                          if (!obj_params.parameters?.api) {
                              console.error('wrong parameter, should set api or args!')
                              return false
                          }
                          cmd.parameters = obj_params.parameters
                      }
          
                      // save session data
                      this.session_array[cmd.session] = obj_params
          
                      if (this.socket.readyState == WebSocket.OPEN) {
                          this.socket.send(JSON.stringify(cmd))
                          // console.log("send out cmd: "+JSON.stringify(cmd))
                      } else {
                          this.msgs.push(JSON.stringify(cmd))
                      }
          
                      return true
                  }
              }
          
              window.vowOS.tvinfo = {
                  apiVersion: '3.0.1',
                  getUIVersion: function() {
                      const ret = window.vowOS.service.syncExecute('hiutils', {
                            api: 'getUIVersion',
                            args: ''
                      })
          
                      if(ret?.ret) {
                          return JSON.parse(ret.msg)
                      }
                  },
                  getOSVersion: function() {
                      const ret = window.vowOS.service.syncExecute('hiutils', {
                            api: 'getOSVersion',
                            args: ''
                      })
          
                      if(ret?.ret) {
                          return ret?.msg
                      }
                  },
                  getStoreMode: function() {
                      return TvInfo_getParam('storeMode')
                  },
                  getHotelMode: function() {
                      return TvInfo_getParam('isHotelMode')
                  },
                  getKidsMode: function() {
                      return TvInfo_getParam('kidsMode')
                  },
                  setKidsMode: function(data) {
                      return TvInfo_setParam('kidsMode', data)
                  },
                  getPanelType: function() {
                      return TvInfo_getParam('panelType')
                  },
                  getTimeFormat: function() {
                      return TvInfo_getParam('timeFormat')
                  },
                  setBrightness: function(data) {
                      return TvInfo_setParam('brightness', data)
                  },
                  getBrightness: function() {
                      return TvInfo_getParam('brightness')
                  },
                  setContrast: function(data) {
                      return TvInfo_setParam('contrast', data)
                  },
                  getContrast: function() {
                      return TvInfo_getParam('contrast')
                  },
                  getChipId: function() {
                      return TvInfo_getParam('chipId')
                  }
              }
          
              window.vowOS.store = {
                  getInstalledPkgs: function() {
                      const ret = window.vowOS.service.syncExecute('pkgmgr', {
                            api: 'getInstalledPkgs',
                            args: ''
                      })
                      return ret
                  },
                  installApp: function(appinfo, callback) {
                      if (!appinfo || typeof (appinfo) != 'object') {
                          callback({ret: false, msg:{appId: '', message:'wrong param'}})
                          return false
                      }
                      if(!appinfo?.packageName) {
                          const ret = Hisense_installApp(appinfo.appId, appinfo.appName, appinfo.thumbnail, appinfo.iconSmall, appinfo.iconBig, appinfo.appUrl, appinfo.storetype, callback, appinfo.configUrl, appinfo.configUrlDownload, appinfo.mediaId)
                          callback({ret: ret, msg:{appId: appinfo?.appId, message: ret? "succeed" : "install failed!"}})
                          return ret
                      } else {
                          // package app
                          const param = {
                               pkgName: appinfo?.packageName,
                               version: '',
                               appId: appinfo?.appId
                          }
                          this.sendPkgmgrRequest('install', param, appinfo, callback)
                          return true
                      }
                  },
          
                  sendPkgmgrRequest: function(api, args, appinfo, callback) {
                      let ret = true
                      // encode param
                      const encodedData = encodeURIComponent(JSON.stringify(args));
                      const url = `https://localhost:9888/service/pkgmgr?api=${api}&args=${encodedData}`;
                      const xhr = new XMLHttpRequest();
                      xhr.onload = function() {
                          if (xhr.status >= 200 && xhr.status < 300) {
                              // 请求成功，处理响应数据
                              console.log(xhr.responseText)
                              const response = JSON.parse(xhr.responseText)
                              if(response?.ret && api == 'install') {
                                  // TODO: read from config file
                                  const path = `file:///APPS/pkgs/${args?.pkgName}/index.html`
                                  // write path into Appinfo.json
                                  ret = Hisense_installApp(args?.appId, args?.pkgName, appinfo?.thumbnail, appinfo?.iconSmall, appinfo?.iconBig, path, 'hisense', callback, appinfo?.configUrl, appinfo?.configUrlDownload, appinfo?.mediaId)
                              }
          
                              callback({ret: response?.ret, msg:{appId: args?.appId, message: response?.msg}})
                          } else {
                              // 请求失败，处理错误
                              ret = false
                              callback({ret: ret, msg:{appId: args?.appId, message: xhr.responseText}})
                          }
                      }
          
                      xhr.open('GET', url);
                      xhr.send();
                      return ret
                  }
              }
          
              window.vowOS.service.socketonopen = function(e) {
                  console.log('websocket opened')
                  if (vowOS.service.msgs.length > 0) vowOS.service.msgs.reverse()
                  while (vowOS.service.msgs.length > 0) {
                      vowOS.service.socket.send(vowOS.service.msgs.pop())
                  }
              }
          
              window.vowOS.service.socketonmessage = function(e) {
                  console.log('websocket received message:' + e.data)
                  try {
                      const params = JSON.parse(e.data)
                      const callbacks = vowOS.service.session_array[params.session] != undefined ? vowOS.service.session_array[params.session] : {}
                      const event_return = callbacks?.onMessage
          
                      console.log('callbacks:', params, params.msg.deviceID, params.msg.deviceModel, params.msg.osVersion, params.msg.serialNumber);
          
                      // localStorage.setItem("deviceIDInfo", params.msg.deviceID);
                      // localStorage.setItem("modelCode", params.msg.tvBrand);
                      // localStorage.setItem("version", params.msg.osVersion);
                      // localStorage.setItem("serialNumber", params.msg.serialType);
                      // localStorage.setItem("macAddress", params.msg.chipsetName);
                      // localStorage.setItem("uuid", params.msg.deviceID);
                      // localStorage.setItem("systemInfo", params.msg.tvBrand);
                      // localStorage.setItem("modelName", params.msg.modelName);
          
                      // handle event
                      if (event_return && params?.event) {
                          const event = {
                              event: params?.event ?? 'unknown',
                              msg: params?.msg ?? 'invalid format'
                          }
                          return callbacks.onMessage(event)
                      }
                      // handle api case
                      if (params.ret) {
                          callbacks?.onSuccess?.(params.msg)
                      } else {
                          callbacks?.onError?.(params.msg)
                      }

                      localStorage.setItem("deviceIDInfo", params.msg.deviceID);
                      localStorage.setItem("version", params.msg.osVersion);
                      localStorage.setItem("serialNumber", params.msg.serialType);
                      localStorage.setItem("macAddress", params.msg.chipsetName);
                      localStorage.setItem("uuid", params.msg.deviceID);
                      localStorage.setItem("systemInfo", params.msg.tvBrand);
                      localStorage.setItem("modelName", params.msg.modelName);
                      localStorage.setItem("modelCode", params.msg.tvBrand);
          
                      callbacks?.onComplete?.(params.msg)
                      if (callbacks.method != 'register') {
                          console.log('removed session:' + params.session)
                          delete vowOS.service.session_array[params.session]
                      }
                  } catch (e) {
                      console.log(e)
                  }
              }
          
              // e.reason = session
              window.vowOS.service.socketonclose = function(e) {
                  console.log('websocket closed, code:%d / reason:%s', e.code, e.reason)
          
                  vowOS.service.socket = null
                  vowOS.service.msgs.length = []
          
                  for (const session in vowOS.service.session_array) {
                      if (vowOS.service.session_array[session]?.onError) {
                          const callbacks = vowOS.service.session_array[session]
                          delete vowOS.service.session_array[session]
                          console.log('call onError for session %s!', session)
                          callbacks.onError('session is closed abnormally.code ' + e.code)
                      }
                  }
              }
          
              window.vowOS.service.socketonerror = function(error) {
                  console.log('got error:' + error.msg)
              }
          
              // get param
              TvInfo_getParam = function(key) {
                  if (!(TvInfo_Json.hasOwnProperty(key) && TvInfo_Json[key] != undefined)) {
                      var ret = vowOS.service.syncExecute('tvinfo', {
                          api: key
                      })
          
                      if (ret?.ret) {
                          var value = ret?.msg
                          if (value[key] != null) {
                              console.log('[tvinfo] key:' + key + ', value: ' + value[key])
                              return value[key]
                          }
                      } else {
                          console.log('HTTP ERROR CODE: ' + ret.msg)
                      }
          
                      return null
                  }
          
                  console.log('[tvinfo] key:' + key + ', value: ' + TvInfo_Json[key])
                  return TvInfo_Json[key]
              }
          
              // set param
              TvInfo_setParam = function(key, value) {
                  vowOS.service.execute('phoenix://service/tvinfo', {
                      method: 'callAPI',
                      parameters: {
                          api: 'setbiz',
                          args: {
                              key: key,
                              value: value.toString()
                          }
                      },
                      timeout: 2,
                      onSuccess: function(ret) { console.log('got result: %d - %s', ret) }
                  })
          
                  return true
              }
          
              // get param
              TvInfo_getCurrentParam = function(key, value) {
                  const xhr_response = vowOS.service.syncExecute('tvinfo', {
                      api: key,
                      args: value
                  })
                  return xhr_response.msg
              }
          
              // set Observer
              TvInfo_setParamObserver = function(key, callback) {
                  console.log('set observer: ' + key)
                  vowOS.service.execute('phoenix://service/tvinfo', {
                      method: 'register',
                      parameters: {
                          api: key
                      },
                      timeout: 2,
                      onMessage: function(ret) {
                          if (ret) {
                              updateJSON(ret)
                              callback(ret?.msg)
                          }
                      }
                  })
          
                  return true
              }
          
              // clear observe
              TvInfo_clearParamObserver = function(key) {
                  console.log('unregister observer: ' + key)
                  vowOS.service.execute('phoenix://service/tvinfo', {
                      method: 'unregister',
                      parameters: {
                          api: key
                      },
                      timeout: 2
                  })
          
                  return true
              }
          
              // log report
              TvInfo_writeTvRunLog = function(type, msg) {
                  var runlog = {}
                  runlog.type = type
                  runlog.msg = msg
                  vowOS.service.execute('phoenix://service/hiutils', {
                      method: 'callAPI',
                      parameters: {
                          api: 'writeTvRunLog',
                          args: JSON.stringify(runlog)
                      },
                      timeout: 2,
                      onSuccess: function(ret) { console.log('got result: %d - %s', ret) }
                  })
                  return true
              }
          
              // hi_utils
              HiUtils_createRequest = function(type, msg) {
                  const xhr_response = vowOS.service.syncExecute('hiutils', {
                      api: type,
                      args: msg
                  })
                  return xhr_response
              }
          
              onLoadPage()
          
              // ====================================================
              function onLoadPage() {
              // create websocket
              // console.time("WebsocketTest");
                  createWebsocket()
              }
          
              // create websocket
              function createWebsocket() {
                  try {
                      init()
                  } catch (e) {
                      console.log('websocket error')
                  }
              }
          
              function init() {
                  vowOS.service.execute('phoenix://service/tvinfo', {
                      method: 'callAPI',
                      parameters: {
                          api: 'initialData'
                      },
                      timeout: 2,
                      onSuccess: function(ret) { addToJSON(ret) }
                  })
              }
          
              function addToJSON(str) {
                  if (!!str && typeof str == 'object') {
                      for (var k in str) {
                          TvInfo_Json[k] = str[k]
                      }
                      return true
                  } else {
                      return false
                  }
              }
          
              function updateJSON(data) {
                  console.log('update JSON: ', JSON.stringify(data))
                  if (data && typeof data == 'object') {
                      TvInfo_Json[data?.event] = data?.msg
                      return true
                  } else {
                      return false
                  }
              }
          })()
          
          })(window);
      } catch (error) {
        console.error("Error fetching VIDAA OS system info:", error);
      }
    };

    getSystemInfo();
  }, []);

  return (
    <div>
      {/* <h3>VIDAA OS TV System Information</h3>
      <pre>{JSON.stringify(systemInfo, null, 2)}</pre> */}
    </div>
  );
};

// const VidaaDeviceID = () => {
//   const [deviceIDInfo, setDeviceIDInfo] = useState(null);

//   useEffect(() => {
//     const getDeviceID = async () => {
//       try {
//         if (window.vowOS && window.vowOS.service) {
//           const idInfo = await window.vowOS.service.getDeviceID();
//           setDeviceIDInfo(idInfo);

//           localStorage.setItem("deviceIDInfo", JSON.stringify(idInfo));
//           localStorage.setItem("uuid", idInfo.deviceId || "Unknown");
//           localStorage.setItem("macAddress", idInfo.macAddress || "Unknown");
//         } else {
//           console.error("VIDAA OS SDK is not available.");
//         }
//       } catch (error) {
//         console.error("Error fetching VIDAA OS device ID info:", error);
//       }
//     };

//     getDeviceID();
//   }, []);

//   return (
//     <div>
//       {/* <h3>VIDAA OS Device ID Information</h3>
//       <pre>{JSON.stringify(deviceIDInfo, null, 2)}</pre> */}
//     </div>
//   );
// };

export default VidaaTVInfo;
